import "Shared/bootstrap";

// Pusher required as import for Echo to function
import Pusher from "pusher-js";
import Echo from "laravel-echo";
import { isPublicUrl } from "Shared/utils/isPublicUrl";

if (!isPublicUrl()) {
  window.Echo = new Echo({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: window.location.hostname,
    wssPort: 2053,
    enabledTransports: ["ws", "wss"],
  });
}
